"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PageTypes;
(function (PageTypes) {
    PageTypes[PageTypes["Login"] = 0] = "Login";
    PageTypes[PageTypes["EventList"] = 1] = "EventList";
    PageTypes[PageTypes["UserList"] = 2] = "UserList";
    PageTypes[PageTypes["CustomerList"] = 3] = "CustomerList";
    PageTypes[PageTypes["CustomerDetail"] = 4] = "CustomerDetail";
    PageTypes[PageTypes["CustomerEdit"] = 5] = "CustomerEdit";
    PageTypes[PageTypes["CompanyDetail"] = 6] = "CompanyDetail";
    PageTypes[PageTypes["CompanyDetailPage"] = 7] = "CompanyDetailPage";
    PageTypes[PageTypes["RequestPasswordReset"] = 8] = "RequestPasswordReset";
    PageTypes[PageTypes["PasswordResetRequestText"] = 9] = "PasswordResetRequestText";
    PageTypes[PageTypes["ResetPassword"] = 10] = "ResetPassword";
    PageTypes[PageTypes["UserDetail"] = 11] = "UserDetail";
    PageTypes[PageTypes["RequestAccess"] = 12] = "RequestAccess";
    PageTypes[PageTypes["CompleteAccessRequest"] = 13] = "CompleteAccessRequest";
    PageTypes[PageTypes["EventLanding"] = 14] = "EventLanding";
    PageTypes[PageTypes["History"] = 15] = "History";
    PageTypes[PageTypes["VendorUserList"] = 16] = "VendorUserList";
    PageTypes[PageTypes["VendorUserDetail"] = 17] = "VendorUserDetail";
    PageTypes[PageTypes["EventConfiguration"] = 18] = "EventConfiguration";
    PageTypes[PageTypes["UserProfile"] = 19] = "UserProfile";
    PageTypes[PageTypes["NewEvent"] = 20] = "NewEvent";
    PageTypes[PageTypes["InventoryList"] = 21] = "InventoryList";
    PageTypes[PageTypes["InventoryDetailPage"] = 22] = "InventoryDetailPage";
    PageTypes[PageTypes["UserGroupList"] = 23] = "UserGroupList";
    PageTypes[PageTypes["UserGroupDetail"] = 24] = "UserGroupDetail";
    PageTypes[PageTypes["InventorySchedulerPage"] = 25] = "InventorySchedulerPage";
    PageTypes[PageTypes["EventOverviewReport"] = 26] = "EventOverviewReport";
    PageTypes[PageTypes["InventoryForecast"] = 27] = "InventoryForecast";
    PageTypes[PageTypes["SystemSettings"] = 28] = "SystemSettings";
    PageTypes[PageTypes["EventHistory"] = 29] = "EventHistory";
    PageTypes[PageTypes["CustomerCompanyList"] = 30] = "CustomerCompanyList";
    PageTypes[PageTypes["CustomerCompanyDetail"] = 31] = "CustomerCompanyDetail";
    PageTypes[PageTypes["CustomerCompanyEdit"] = 32] = "CustomerCompanyEdit";
    PageTypes[PageTypes["VendorCompaniesPage"] = 33] = "VendorCompaniesPage";
    PageTypes[PageTypes["VendorCompanyDetailPage"] = 34] = "VendorCompanyDetailPage";
    PageTypes[PageTypes["AttendeeReport"] = 35] = "AttendeeReport";
    PageTypes[PageTypes["AttendeeBoldReport"] = 36] = "AttendeeBoldReport";
    PageTypes[PageTypes["MeetingsReportPage"] = 37] = "MeetingsReportPage";
    PageTypes[PageTypes["MeetingsBoldReportPage"] = 38] = "MeetingsBoldReportPage";
    PageTypes[PageTypes["TenantList"] = 39] = "TenantList";
    PageTypes[PageTypes["TenantDetailPage"] = 40] = "TenantDetailPage";
    PageTypes[PageTypes["HotelReportPage"] = 41] = "HotelReportPage";
    PageTypes[PageTypes["TransportationReportPage"] = 42] = "TransportationReportPage";
    PageTypes[PageTypes["VendorUserProfile"] = 43] = "VendorUserProfile";
    PageTypes[PageTypes["VendorEventList"] = 44] = "VendorEventList";
    PageTypes[PageTypes["VendorEmailTemplates"] = 45] = "VendorEmailTemplates";
    PageTypes[PageTypes["VendorEmailTemplate"] = 46] = "VendorEmailTemplate";
    PageTypes[PageTypes["VendorEventLandingPage"] = 47] = "VendorEventLandingPage";
    PageTypes[PageTypes["UrlAssignerPage"] = 48] = "UrlAssignerPage";
    PageTypes[PageTypes["MeetingPlacard"] = 49] = "MeetingPlacard";
    PageTypes[PageTypes["RoomDisplayPage"] = 50] = "RoomDisplayPage";
    PageTypes[PageTypes["TableDisplayPage"] = 51] = "TableDisplayPage";
    PageTypes[PageTypes["AttendeeDataGridReport"] = 52] = "AttendeeDataGridReport";
    PageTypes[PageTypes["VenueDataGridReport"] = 53] = "VenueDataGridReport";
    PageTypes[PageTypes["EmailTemplates"] = 54] = "EmailTemplates";
    PageTypes[PageTypes["EmailTemplate"] = 55] = "EmailTemplate";
    PageTypes[PageTypes["VendorCompanyInfo"] = 56] = "VendorCompanyInfo";
    PageTypes[PageTypes["GolfCartReport"] = 57] = "GolfCartReport";
    PageTypes[PageTypes["DiningReport"] = 58] = "DiningReport";
    PageTypes[PageTypes["NamePlateReport"] = 59] = "NamePlateReport";
    PageTypes[PageTypes["HelpUrls"] = 60] = "HelpUrls";
    PageTypes[PageTypes["DeviceRegistration"] = 61] = "DeviceRegistration";
    PageTypes[PageTypes["SsoLogin"] = 62] = "SsoLogin";
    PageTypes[PageTypes["AllMeetingsList"] = 63] = "AllMeetingsList";
    PageTypes[PageTypes["MeetingNotesReportPage"] = 64] = "MeetingNotesReportPage";
    PageTypes[PageTypes["BoldReportsReportViewer"] = 65] = "BoldReportsReportViewer";
    PageTypes[PageTypes["DayPassReport"] = 66] = "DayPassReport";
    //<NEXT>
})(PageTypes || (PageTypes = {}));
exports.default = PageTypes;
